import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Modal from 'modules/common/components/Modal';
import PrintIFrame from 'modules/common/components/PrintIFrame';

function PrintMayorsPermitModal({
  id,
  email,
  token,
}) {
  const [printLink, setPrintLink] = useState();

  const generateLink = () => {
    const url = `https://logos-ws.multidemos.com/api/v1/administrators/mayors_permit/${id}?email=${email}&bearer_token=${token}`;
    setPrintLink(url);
  };

  const renderFrame = () => {
    if (!_.isEmpty(id) && !_.isEmpty(email) && !_.isEmpty(token)) {
      if (!_.includes(printLink, undefined)) {
        return <PrintIFrame url={printLink} />;
      }
    }
    return null;
  };

  useEffect(() => {
    generateLink();
  }, []);

  useEffect(() => {
    generateLink();
  }, [id, email, token]);

  return (
    <Modal.Body>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0">
            {renderFrame()}
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

PrintMayorsPermitModal.propTypes = {
  id: PropTypes.string,
  email: PropTypes.string,
  token: PropTypes.string,
};

PrintMayorsPermitModal.defaultProps = {
  id: '',
  email: '',
  token: '',
};

export default PrintMayorsPermitModal;
